import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    style: { "height": "0", "opacity": "0" }
};
const _hoisted_2 = { id: "test-cmds" };
const _hoisted_3 = { id: "test-error" };
const _hoisted_4 = { id: "test-msgs" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_ctx.testSpecified)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$store.state.test.cmds), 1),
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$store.state.test.error), 1),
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$store.state.test.msgs), 1)
        ]))
        : _createCommentVNode("", true);
}
